import { __awaiter, __decorate } from "tslib";
import CatalogItem from '@slickdeals/durango/dist/javascript/core/catalogItem';
import { catalogItem } from '@slickdeals/durango/dist/javascript/decorators/catalogItem';
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import Injector, { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import Logger from '@slickdeals/durango/dist/javascript/utilities/logger';
import { joinLoyalty } from '../utilities/loyalty';
import { name as heapName } from '../heap/heap';
import '../../scss/patterns/cashbackOneClickJoinButton.scss';
import ButtonLoader from '../utilities/buttonLoader';
export const name = 'CashbackOneClickJoinButton';
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-p-cashbackOneClickJoinButton";
})(ClassNames || (ClassNames = {}));
export const dependencies = Object.assign({}, Injector.createDependency(heapName, InjectorScope.Singleton));
let CashbackOneClickJoinButton = class CashbackOneClickJoinButton extends CatalogItem {
    constructor(heap, options) {
        super(options);
        this.heap = heap;
        this.options = options;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            _super.init.call(this);
            this.element = yield CatalogItem.loadElement(name, this.options);
            this.element.addEventListener('click', yield this.handleClick.bind(this));
            this.trackImpression();
        });
    }
    handleClick(event) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const activateButton = event.currentTarget;
            yield ButtonLoader.showLoader(activateButton);
            const joinSource = (_a = this.options.joinSource) !== null && _a !== void 0 ? _a : 'GenericOneClickJoin';
            const joinResult = yield joinLoyalty(joinSource);
            if (joinResult.isLoyaltyUser) {
                ButtonLoader.showContents(activateButton);
                activateButton.textContent = 'CASHBACK ACTIVATED';
            }
            if (this.options.refreshOnClick) {
                window.location.reload();
            }
        });
    }
    trackImpression() {
        this.heap.track('Rewards For All - CashbackOneClickJoinButton - Impression')
            .catch(err => Logger.warn(`Failed to track ${name} Impression: ${err}`));
    }
};
CashbackOneClickJoinButton = __decorate([
    injectable(name, dependencies),
    catalogItem(name)
], CashbackOneClickJoinButton);
export default CashbackOneClickJoinButton;
